import React from 'react';
import CandleRoomApp from '../candleRoom/App';

function Interactive() {
  return <CandleRoomApp />;
}

export default Interactive;
